const DEFAULT_SPACE_THRESHOLD_TO_BREAK_WORD = 3;

export const shouldBreakWord = (text, alternateThreshold) => {
  const threshold = alternateThreshold || DEFAULT_SPACE_THRESHOLD_TO_BREAK_WORD;
  return text.toString().split(' ').length <= threshold;
};
